export default {

    Img(url, suffix = "") {
        if (url) {
            return url.indexOf("://") >= 0 ? url + suffix : this.Config.base_img + url + suffix
        } else {
            return ""
        }
    },
    Token(token) {
        if (token === undefined) {
            return this.Cache('token')
        } else if (token === null) {
            return this.Cache('token', null)
        } else if (token) {
            return this.Cache('token', token)
        }
    },
    Cache(key, val) {
        if (window.localStorage && key) {
            if (val === undefined) {
                try {
                    return JSON.parse(window.localStorage[key]);
                } catch (err) {
                    return window.localStorage[key];
                }
            } else if (val === null) {
                window.localStorage.removeItem(key)
                return undefined
            } else {
                window.localStorage[key] = JSON.stringify(val)
                return val
            }
        } else {
            return null
        }
    },
    CacheClean() {
        if (window.localStorage) {
            window.localStorage.clean();
            return undefined;
        }
    },
    timeConves: function (d) {
        return d.getFullYear() + '-' + (d.getMonth() + 1 < 10 ? '0' + (d.getMonth() + 1) : d.getMonth() + 1) + '-' + (d.getDate() < 10 ? '0' + d.getDate() : d.getDate());
    },
    Time(time, format = "yyyy-MM-dd hh:mm:ss") {
        return this.Untimestamp(Date.parse(new Date(time)) / 1000, format)
    },
    Timestamps(date) {
        let time = new Date(date)
        return Date.parse(time) / 1000
    },
    Thousand(num) {
        let re = /(\d{1,3})(?=(\d{3})+(?:$|\D))/g
        return String(num).replace(re, "$1,")
    },
    Timestamp(date) {
        let time = date ? new Date(date) : new Date()
        return Date.parse(time) / 1000
    },
    //计算周时间
    calculation_wektime() {
        let time = this.Timestamp(this.times);
        let now = new Date(time * 1000); //当前日期
        let nowDayOfWeek = now.getDay(); //今天本周的第几天
        let nowYear = now.getYear(); //当前年
        let nowMonth = now.getMonth(); //月
        let nowDay = now.getDate(); //日
        nowYear += nowYear < 2000 ? 1900 : 0;
        let weekStartDate = new Date(
            nowYear,
            nowMonth,
            nowDay - nowDayOfWeek + 1
        );
        return weekStartDate;
    },
    Untimestamp(time, format = "yyyy-MM-dd hh:mm:ss") {
        if (!time) {
            return '-'
        }
        let d = new Date(time * 1000)
        let date = {
            "M+": d.getMonth() + 1,
            "d+": d.getDate(),
            "h+": d.getHours(),
            "m+": d.getMinutes(),
            "s+": d.getSeconds(),
            "q+": Math.floor((d.getMonth() + 3) / 3),
            "S+": d.getMilliseconds()
        }
        if (/(y+)/i.test(format)) {
            format = format.replace(RegExp.$1, (d.getFullYear() + '').substr(4 - RegExp.$1.length))
        }
        for (let k in date) {
            if (new RegExp("(" + k + ")").test(format)) {
                format = format.replace(RegExp.$1, RegExp.$1.length == 1 ?
                    date[k] :
                    ("00" + date[k]).substr(("" + date[k]).length))
            }
        }
        return format
    },
    formatNum(num) {
        if (num != '') {
            return num < 10 ? "0" + num : "" + num;
        } else {
            return '00'
        }
    },
    //将秒数转换为时分秒格式
    formatSeconds(value) {
        var theTime = parseInt(value); // 秒
        var middle = 0; // 分
        var hour = 0; // 小时
        var day = 0; // 天

        if (theTime > 60) {
            middle = parseInt(theTime / 60);
            theTime = parseInt(theTime % 60);
            if (middle > 60) {
                hour = parseInt(middle / 60);
                middle = parseInt(middle % 60);
                if (hour > 24) {
                    day = parseInt(hour / 24);
                    hour = parseInt(hour % 24);
                }
            }
        }
        var result = "" + parseInt(theTime) + "秒";
        if (middle > 0) {
            result = "" + parseInt(middle) + "分" + result;
        }
        if (hour > 0) {
            result = "" + parseInt(hour) + "小时" + result;
        }
        if (day > 0) {
            result = "" + parseInt(day) + "天" + result;
        }
        return result;
    },
    //时间补缺(天)
    getBetweenDateStr(start, end) {
        let result = [];
        result.push(start);
        if (start != end) {
            let beginDay = start.split("-");
            let endDay = end.split("-");
            let diffDay = new Date();
            let dateList = new Array();
            let i = 0;
            diffDay.setDate(beginDay[2]);
            diffDay.setMonth(beginDay[1] - 1);
            diffDay.setFullYear(beginDay[0]);

            while (i == 0) {
                let countDay = diffDay.getTime() + 24 * 60 * 60 * 1000;
                diffDay.setTime(countDay);
                dateList[2] = diffDay.getDate();
                dateList[1] = diffDay.getMonth() + 1;
                dateList[0] = diffDay.getFullYear();
                if (String(dateList[1]).length == 1) {
                    dateList[1] = "0" + dateList[1];
                }
                if (String(dateList[2]).length == 1) {
                    dateList[2] = "0" + dateList[2];
                }
                if (
                    dateList[0] == endDay[0] &&
                    dateList[1] == endDay[1] &&
                    dateList[2] == endDay[2]
                ) {
                    i = 1;
                }
                result.push(
                    dateList[0] + "-" + dateList[1] + "-" + dateList[2]
                );

            }
        }
        return result;
    },
    //时间补缺(月)
    getMonthAll(begin, end) {
        var d1 = begin;
        var d2 = end;
        var dateArry = new Array();
        var s1 = d1.split("-");
        var s2 = d2.split("-");
        var mCount = 0;
        if (parseInt(s1[0]) < parseInt(s2[0])) {
            mCount =
                (parseInt(s2[0]) - parseInt(s1[0])) * 12 +
                parseInt(s2[1]) -
                parseInt(s1[1]) +
                1;
        } else {
            mCount = parseInt(s2[1]) - parseInt(s1[1]) + 1;
        }
        if (mCount > 0) {
            var startM = parseInt(s1[1]);
            var startY = parseInt(s1[0]);
            for (var i = 0; i < mCount; i++) {
                if (startM < 12) {
                    dateArry[i] =
                        startY + "-" + (startM > 9 ? startM : "0" + startM);
                    startM += 1;
                } else {
                    dateArry[i] =
                        startY + "-" + (startM > 9 ? startM : "0" + startM);
                    startM = 1;
                    startY += 1;
                }
            }
        }
        return dateArry;
    },
    Go(name, params = {}) {
        this.$router.push({ name, params })
    },
    GoTo(name, params = {}) {
        this.$router.push({
            path: name,
            query:params
        })
    },
    Rd(name, params = {}) {
        this.$router.replace({ name, params })
    },
    toPath(name) {
        this.$router.replace({ path: name })
    },
    Msg(message, type = 'success') {
        return this.Toast(message, type)
    },
    Toast(message, type = 'error', duration = 3000) {
        return this.$message({ message, type, duration });
    },
    Suc(...opt) {
        return this.Msg(...opt)
    },
    Err(...opt) {
        return this.Toast(...opt)
    },
    Notify(title, message, type = "error") {
        return this.$notify({ title, message, type });
    },

    Extend(old, ...obj) {
        return Object.assign(old, ...obj)
    },
    DataReset(key) {
        return Object.assign(this.$data[key], this.$options.data()[key])
    },
    Origin(obj) {
        return JSON.parse(JSON.stringify(obj));
    },
    ParamsReset() {
        Object.assign(this.$data.params, this.$options.data().params)
    },
    Confirm(callback = new Function, msg = '您确定要操作选定的数据么？', title = '操作数据',) {
        return this.$confirm(msg, title, {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            confirmButtonClass: 'pj-alert-confirm',
            cancelButtonClass: 'pj-alert-cancel',
            type: 'warning',
            closeOnClickModal: false,
            center: true,
        }).then(() => {
            callback()
        }).catch(() => { })
    },
    DelConfirm(callback = new Function, msg = '您确定要删除当前选定的数据么？', title = '删除数据',) {
        return this.$confirm(msg, title, {
            confirmButtonText: '删除',
            cancelButtonText: '取消',
            confirmButtonClass: 'pj-alert-del',
            cancelButtonClass: 'pj-alert-cancel',
            type: 'error',
            center: true
        }).then(() => {
            callback()
        }).catch(() => { })
    },
    AsyncConfirm(callback = new Function, msg = '您确定要操作选定的数据么？', title = '提示') {
        this.$confirm(msg, title, {
            confirmButtonText: "确定",
            cancelButtonText: "取消",
            confirmButtonClass: "pj-alert-confirm",
            cancelButtonClass: "pj-alert-cancel",
            type: "warning",
            closeOnClickModal: false,
            center: true,
            beforeClose: (action, instance, done) => {
                if (action === "confirm") {
                    instance.confirmButtonLoading = true;
                    instance.confirmButtonText = "执行中...";
                    let call_back = function () {
                        done();
                        instance.confirmButtonLoading = false;
                    }
                    callback(call_back)
                } else {
                    done();
                }
            }
        })
            .then(() => { })
            .catch(() => { });

    },
    //手机号码
    phone(value) {
        let patrn = /^1(3|4|5|6|7|8|9)\d{9}$/;
        return patrn.test(value);
    },
    //时间戳转日期
    formatDateTime(prow, column, cellValue, index) {
        if (!cellValue) {
            return cellValue;
        }
        var cellValue = new Date(cellValue);
        var year = 1900 + cellValue.getYear();
        var month = "0" + (cellValue.getMonth() + 1);
        var date = "0" + cellValue.getDate();
        var hour = "0" + cellValue.getHours();
        var minute = "0" + cellValue.getMinutes();
        var second = "0" + cellValue.getSeconds();
        return year + "-" + month.substring(month.length - 2, month.length) + "-" + date.substring(date.length - 2, date.length)
            + " " + hour.substring(hour.length - 2, hour.length) + ":"
            + minute.substring(minute.length - 2, minute.length) + ":"
            + second.substring(second.length - 2, second.length);
    },
    //保留4位小数
    dolt(prow, column, cellValue, index) {
        if (!cellValue) {
            cellValue = 0;
        }
        let c = cellValue.toFixed(4).replace(/\.?0+$/, "")
        let fun = function (e) {
            let r = e.indexOf('.');
            if (r < 0) {
                r = e.length;
                e += '.';
            }
            while (e.length <= r + 4) {
                e += '0';
            }
            let result = '';
            let isNum = e.indexOf('-') > -1 ? true : false
            let t = isNum ? e.substr(1, e.indexOf('.') - 1) : e.substr(0, e.indexOf('.'))
            let y = e.substr(e.indexOf('.'));
            if (t.length <= 3) {
                return e;
            }
            while (t.length > 3) {
                result = ',' + t.slice(-3) + result;
                t = t.slice(0, t.length - 3);
            }
            if (t) { result = t + result; }
            return isNum ? "-" + result + y : result + y;
        }
        let f = parseFloat(c);
        f = Math.round(c * 10000) / 10000;
        let s = f.toString();
        if (s.indexOf('e') > 0) {
            return fun(c);
        }
        return fun(s);
    },
    //保留3位小数
    dolts(cellValue, length = 2) {
        if (!cellValue) {
            cellValue = 0;
        }
        let c = Number(cellValue).toFixed(length).replace(/\.?0+$/, "");
        return c;
    },
    isNull(value) {
        if (this.oisNumber(value)) {
            value = toString(value)
        }
        if (value.replace(/\s+/g, "")) {
            return true;
        } else {
            return false;
        }
    },
    oisArray(value) {
        return value instanceof Array
    },
    oisNumber(value) {
        // return value instanceof Number
        // var re = /^[0-9]+.?[0-9]*/;
        // return re.test(value)
        if (parseFloat(value).toString() == 'NaN') {
            //alert(“请输入数字……”); 
            return false;
        } else {
            return true;
        }
    },
    oisString(value) {
        return value instanceof String
    },
    oisObject(value) {
        return value instanceof Object
    },
    arrayConvert(str) {
        let arr = JSON.parse(str)
        if (this.oisArray(arr)) {
            return arr
        } else {
            return []
        }
    },
    //判断正负数
    isParseInt(n) {
        if (n != Math.abs(n)) {
            return false;
        } else {
            return true
        }
    },
    //查找对象
    findValue(list, key) {
        let item = list.find(ele => {
            return ele.value == key
        })
        if (item) {
            return item.label
        } else {
            return ''
        }
    },
    //查找房间名
    findids(list, key) {
        let item = list.find(ele => {
            return ele.room_id == key
        })
        if (item) {
            return item.room_name
        } else {
            return ''
        }
    },
    findcontent(list, key) {
        let item = list.find(ele => {
            return ele.site_type == key
        })

        if (item) {
            return item.name
        } else {
            return ""
        }
    },
    findc(type, obj, key) {
        if (parseInt(parseInt(type) / 100) == 1) {
            return this.findcontent(obj.kuaisan_list, key)
        } else if (parseInt(parseInt(type) / 100) == 2) {
            return this.findcontent(obj.shishicai_list, key)
        } else if (parseInt(parseInt(type) / 100) == 3) {
            return this.findcontent(obj.pk10_list, key)
        } else if (parseInt(parseInt(type) / 100) == 4) {
            return this.findcontent(obj.xuan11_5_list, key)
        } else if (parseInt(parseInt(type) / 100) == 8) {
            return this.findcontent(obj.fucai3d, key)
        }
    },
    // 数据重组、根据类型分类
    itemize(data, key) {
        let map = {},
            dest = [];
        for (let i = 0; i < data.length; i++) {
            let item = data[i];
            if (!map[item[key]]) {
                dest.push({
                    [key]: item[key],
                    list: [item]
                });
                map[item[key]] = item;
            } else {
                for (let j = 0; j < dest.length; j++) {
                    let dj = dest[j];
                    if (dj[key] == item[key]) {
                        dj.list.push(item);
                        break;
                    }
                }
            }
        }
        return dest;
    },
    //深拷贝
    deepClone(obj) {
        let objClone = Array.isArray(obj) ? [] : {};
        if (obj && typeof obj === "object") {
            for (let key in obj) {
                if (obj.hasOwnProperty(key)) {
                    //判断ojb子元素是否为对象，如果是，递归复制
                    if (obj[key] && typeof obj[key] === "object") {
                        objClone[key] = this.deepClone(obj[key]);
                    } else {
                        //如果不是，简单复制
                        objClone[key] = obj[key];
                    }
                }
            }
        }
        return objClone;
    },
    //js乘法
    accMul(arg1, arg2) {
        var m = 0,
            s1 = arg1.toString(),
            s2 = arg2.toString();
        try {
            m += s1.split(".")[1].length;
        } catch (e) { }
        try {
            m += s2.split(".")[1].length;
        } catch (e) { }
        return (
            (Number(s1.replace(".", "")) * Number(s2.replace(".", ""))) /
            Math.pow(10, m)
        );
    },
    //加
    accAdd(arg1, arg2) {
        let r1, r2;
        try {
            r1 = arg1.toString().split(".")[1].length;
        } catch (e) {
            r1 = 0;
        }
        try {
            r2 = arg2.toString().split(".")[1].length;
        } catch (e) {
            r2 = 0;
        }
        let m = Math.pow(10, Math.max(r1, r2));
        return (arg1 * m + arg2 * m) / m;
    },
    //减
    accSubtr(arg1, arg2) {
        var r1, r2, m, n;
        try {
            r1 = arg1.toString().split(".")[1].length;
        } catch (e) {
            r1 = 0;
        }
        try {
            r2 = arg2.toString().split(".")[1].length;
        } catch (e) {
            r2 = 0;
        }
        m = Math.pow(10, Math.max(r1, r2));
        //动态控制精度长度
        n = r1 >= r2 ? r1 : r2;
        return ((arg1 * m - arg2 * m) / m).toFixed(n);
    },
    //js除法
    divisionMath(arg1, arg2) {
        if (arg1 == 0) {
            return 0;
        } else {
            if (!arg1) return "";
            if (!arg2) return "";
            var t1 = 0,
                t2 = 0,
                r1,
                r2;
            try {
                t1 = arg1.toString().split(".")[1].length;
            } catch (e) { }
            try {
                t2 = arg2.toString().split(".")[1].length;
            } catch (e) { }
            r1 = Number(arg1.toString().replace(".", ""));
            r2 = Number(arg2.toString().replace(".", ""));
            return (r1 / r2) * Math.pow(10, t2 - t1);
        }
    },
    // 保留有效小数
    toPrecision(val) {
        if (val) {
            if (this.oisNumber(val)) {
                return val.toPrecision()
            } else {
                return Number(val).toPrecision()
            }
        } else {
            return val
        }
    },
    stringSplit(str) {
        let array = str.split(";");
        let data = [];
        array.forEach(item => {
            let unit = item.split(",");
            data.push(unit);
        });
        return data
    },
    getPropsDetails(arr) {
        let result = [];
        if (arr[0] == "") {
            arr = [["1001", "100"]]
        }
        arr.forEach(item => {
            let unit = {
                item_id: Number(item[0]),
                count: Number(item[1])
            };
            result.push(unit);
        });
        return result;
    }
}


// WEBPACK FOOTER //
// ./src/lib/methods.js